// extracted by css-extract-rspack-plugin
export default {"distanceContainer":"distanceFromCityCenter2-module__distanceContainer"};